/*
 * Maison Artsen — packs de pinceaux offerts, tenus à l'équilibre.
 *
 * Règle : autant de packs offerts que d'articles éligibles dans le panier.
 *   Pack de 9 pinceaux  ↔  articles de « Coffrets 6 Mini-Toiles » (petit-format)
 *   Pack de 3 pinceaux  ↔  articles de « Les Grands Formats » (grand-format)
 *
 * Le script ajuste dans les deux sens, à chaque mutation du panier et à chaque
 * chargement de page : il ajoute le pack manquant, complète la quantité, la réduit
 * quand la cliente retire un article, et retire la ligne quand il ne reste plus rien
 * d'éligible. C'est ce dernier cas qui a produit les réclamations SAV du 06-08/08/2026 :
 * un grand format commandé seul repartait avec « Pack de 9 pinceaux » sur le bon d'envoi.
 *
 * La réponse rendue au thème décrit déjà le panier corrigé : la cliente ne voit jamais
 * un état intermédiaire faux.
 *
 * Périmètre limité aux deux packs de pinceaux : produits à 0,00 €, SKU DO-NOT-SHIP-IT,
 * vendus nulle part ailleurs — les manipuler ne peut casser aucune vente. Le mini
 * chevalet garde sa propre mécanique dans `snippets/ma-auto-chevalet.liquid`.
 */
(function () {
  'use strict';

  // variante du pack offert → collection qui y donne droit
  var REGLES = {
    51901697163601: 'coffret',      // Pack de 9 pinceaux
    53421017465169: 'grand_format'  // Pack de 3 pinceaux
  };

  var URL_PANIER = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var fetchOrigine = window.fetch.bind(window);
  var enCours = false;

  function racine() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function poster(chemin, corps) {
    return fetchOrigine(racine() + chemin, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(corps)
    });
  }

  function lireEtat() {
    return fetchOrigine(racine() + '?section_id=ma-gift-guard', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/data-ma-gift-guard[^>]*>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : null;
      });
  }

  // Ce qu'il faut faire pour que chaque pack soit à la bonne quantité.
  function ajustements(etat) {
    if (!etat || !etat.lines) return [];
    var eligibles = { coffret: 0, grand_format: 0 };
    var lignesCadeau = {};

    etat.lines.forEach(function (l) {
      if (REGLES[l.variant_id]) { lignesCadeau[l.variant_id] = l; return; } // un cadeau n'ouvre pas droit à un cadeau
      if (l.coffret) eligibles.coffret += l.quantity;
      if (l.grand_format) eligibles.grand_format += l.quantity;
    });

    return Object.keys(REGLES).reduce(function (actions, id) {
      var voulu = eligibles[REGLES[id]];
      var ligne = lignesCadeau[id];
      var actuel = ligne ? ligne.quantity : 0;
      if (voulu === actuel) return actions;
      if (ligne) actions.push({ id: ligne.key, quantity: voulu });                 // ajuste ou retire
      else actions.push({ ajout: true, id: Number(id), quantity: voulu });         // pose la ligne
      return actions;
    }, []);
  }

  // Retourne true si le panier a été touché.
  function equilibrer() {
    return lireEtat()
      .then(function (etat) {
        var actions = ajustements(etat);
        if (!actions.length) return false;
        return actions
          .reduce(function (chaine, a) {
            return chaine.then(function () {
              return a.ajout
                ? poster('cart/add.js', { items: [{ id: a.id, quantity: a.quantity }] })
                : poster('cart/change.js', { id: a.id, quantity: a.quantity });
            });
          }, Promise.resolve())
          .then(function () { return true; });
      })
      .catch(function () { return false; });
  }

  // Le thème demande des sections rendues (`sections=cart-drawer,cart-icon-bubble`)
  // dans le corps de sa requête, en FormData ou en JSON selon le chemin de code.
  function sectionsDemandees(init) {
    var b = init && init.body;
    if (!b) return null;
    if (typeof FormData !== 'undefined' && b instanceof FormData) {
      return b.get('sections') ? { sections: b.get('sections'), sections_url: b.get('sections_url') } : null;
    }
    if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
      return b.get('sections') ? { sections: b.get('sections'), sections_url: b.get('sections_url') } : null;
    }
    if (typeof b !== 'string') return null;
    try {
      var d = JSON.parse(b);
      return d && d.sections ? { sections: d.sections, sections_url: d.sections_url } : null;
    } catch (e) {
      var p = new URLSearchParams(b);
      return p.get('sections') ? { sections: p.get('sections'), sections_url: p.get('sections_url') } : null;
    }
  }

  // Après ajustement, on rend au thème une réponse qui décrit le panier corrigé, avec
  // les mêmes sections que celles qu'il avait demandées : il réaffiche le bon panier
  // du premier coup.
  function reponseCorrigee(init) {
    var corps = { updates: {} };
    var s = sectionsDemandees(init);
    if (s) {
      corps.sections = s.sections;
      corps.sections_url = s.sections_url || window.location.pathname;
    }
    return poster('cart/update.js', corps);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promesse = fetchOrigine.apply(null, arguments);
    if (!URL_PANIER.test(url) || enCours) return promesse;

    return promesse.then(function (reponse) {
      if (!reponse.ok) return reponse;
      enCours = true;
      return equilibrer()
        .then(function (touche) {
          enCours = false;
          return touche ? reponseCorrigee(init) : reponse;
        })
        .catch(function () { enCours = false; return reponse; });
    });
  };

  // Paniers constitués avant l'arrivée de ce script, et ajouts faits sans JS
  // (soumission classique du formulaire d'upsell).
  function auChargement() {
    equilibrer().then(function (touche) {
      if (touche && /\/cart(\/|$)/.test(window.location.pathname)) window.location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', auChargement);
  } else {
    auChargement();
  }
})();
